import React, { useState } from 'react';
import { Button } from '@guildeducationinc/recess';
import { clickable } from '@src/analytics';
import LifecycleDatePicker, { DatePickerAction } from '../LifecycleDatePicker/LifecycleDatePicker';

export interface CompletionDateConfirmationProps {
  setStartingSlide: (slide: number) => void;
}

const CompletionDateConfirmation: React.FC<CompletionDateConfirmationProps> = ({
  setStartingSlide,
}) => {
  const [showDateInput, setShowDateInput] = useState(false);
  const [datePickerAction, setDatePickerAction] = useState<DatePickerAction | undefined>(undefined);

  const handleConfirm = () => {
    clickable({
      loggedIn: true,
      product: 'home',
      tag: 'llc_completion_date',
      text: 'confirm',
      type: 'button',
    });
    setDatePickerAction(DatePickerAction.SaveActualDate);
    setShowDateInput(true);
  };

  const handleNotFinished = () => {
    clickable({
      loggedIn: true,
      product: 'home',
      tag: 'llc_completion_date',
      text: 'i_have_not_finished',
      type: 'button',
    });
    setDatePickerAction(DatePickerAction.UpdateExpectedDate);
    setShowDateInput(true);
  };

  return (
    <>
      {showDateInput ? (
        <LifecycleDatePicker action={datePickerAction} setStartingSlide={setStartingSlide} />
      ) : (
        <div>
          <Button appearance='primary' onClick={handleConfirm}>
            Confirm
          </Button>

          <Button appearance='ghost' onClick={handleNotFinished}>
            I have not finished
          </Button>
        </div>
      )}
    </>
  );
};

export default CompletionDateConfirmation;
